import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AppStateService } from '@services/app-state.service';
import { Subscription } from 'rxjs';

export interface Step {
  id: number;
  label: string;
  icon?: string;
  route: string;
}

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './app-stepper.component.html',
  styleUrls: ['./app-stepper.component.scss']
})
export class AppStepperComponent implements OnInit, OnDestroy {
  currentStep: number = 1;

  steps: Step[] = [
    { id: 1, label: 'Pretraga', icon: 'search', route: '/search' },
    { id: 2, label: 'Provjera', icon: 'verified_user', route: '/verify' },
    { id: 3, label: 'Kredit', icon: 'account_balance_wallet', route: '/credit' },
    { id: 4, label: 'Pošalji', icon: 'send', route: '/send' }
  ];

  private stepSubscription?: Subscription;

  constructor(
    private appState: AppStateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.stepSubscription = this.appState.currentStep$.subscribe(step => {
      this.currentStep = step;
    });
  }

  ngOnDestroy(): void {
    if (this.stepSubscription) {
      this.stepSubscription.unsubscribe();
    }
  }

  get stepsWithStatus(): Step[] {
    return this.steps.map(step => ({
      ...step,
      status: this.getStepStatus(step.id)
    }));
  }

  protected getStepStatus(stepId: number): "pending" | "active" | "completed" {
    if (stepId < this.currentStep) {
      return 'completed';
    }
    if (stepId === this.currentStep) {
      return 'active';
    }
    return 'pending';
  }

  onStepClick(step: Step): void {
    // Only allow navigation to completed or active steps
    if (step.id <= this.currentStep) {
      this.router.navigate([step.route]);
    }
  }
}
